export default {
	isFetching: false,
	data: null,
	error: null,
	status: '',
	passo_atual_status: '',
	passo_atual_tipo: '',
};
